import { BaseFetch } from "../main-model";
export default class ScholarshipModel extends BaseFetch {
  getScholarshipBy = (data) =>
    this.authFetch({
      url: "scholarship/getScholarshipBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getScholarshipById = (data) =>
    this.authFetch({
      url: "scholarship/getScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateScholarshipById = (data) =>
    this.authFetch({
      url: "scholarship/updateScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertScholarship = (data) =>
    this.authFetch({
      url: "scholarship/insertScholarship",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteScholarshipById = (data) =>
    this.authFetch({
      url: "scholarship/deleteScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudentInScholarship = (data) =>
    this.authFetch({
      url: "scholarship/insertStudentInScholarship",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentInScholarshipById = (data) =>
    this.authFetch({
      url: "scholarship/updateStudentInScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteStudentInScholarshipAllById = (data) =>
    this.authFetch({
      url: "scholarship/deleteStudentInScholarshipAllById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
